export const SUBSCRIBER_ROLES = [
  { value: 'founder', label: 'Founder / CEO' },
  { value: 'cfo', label: 'CFO' },
  { value: 'cmo', label: 'CMO' },
  { value: 'engineer', label: 'Engineer' },
  { value: 'developer', label: 'Developer' },
  { value: 'vibe_coder', label: 'Vibe Coder' },
  { value: 'operator', label: 'Operator / COO' },
  { value: 'other', label: 'Other' },
] as const;

export function subscriberRoleLabel(value: unknown): string {
  if (typeof value !== 'string' || !value.trim()) return '';
  const slug = value.trim().toLowerCase();
  const known = SUBSCRIBER_ROLES.find((role) => role.value === slug);
  return known?.label ?? value.trim();
}
